import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/ubuntu/download_production/69eac87263911b0014dce30b/softphonesaas/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69eac87263911b0014dce30b/softphonesaas/src/styles/tailwind.css");
